<template>
    <div slot="content" class="tile">
        <template v-for="(action, actionIndex) in actions">
            <div class="tile-content" :key="`tile-${action.$internalId}`">
                <div class="grid-content grid-unstackable align-items-center">
                    <div class="grid-item cursor-pointer" @click="$emit('toggle-action-status', actionIndex)">
                        <h2>{{action.name | unKebabCase}}</h2>
                    </div>
                    <div class="grid-item no-flex">
                        <v-toggle
                            @input="$emit('toggle-action-status', actionIndex)"
                            :value="true"
                            :selected="action.status"/>
                    </div>
                    <div class="grid-item no-flex">
                        <v-icon-button
                            type="basic"
                            size="small"
                            @click="confirmDelete(action, actionIndex)"
                            tooltip="Delete action">
                            <v-icon icon="close"/>
                        </v-icon-button>
                    </div>
                </div>
            </div>
            <send-email
                :key="`component-${action.$internalId}`"
                v-if="action.status"
                :is-form-updating="isFormUpdating"
                :system-event-type="event.eventType"
                :new-action-predicate="newActionPredicate"
                :pre-processor="preProcessor"
                @input="updateAction($event, actionIndex)"
                :validation-aggregator="validationAggregator"
                :action="action"/>
        </template>
        <div class="tile-content">
            <div class="grid-content">
                <div class="grid-item">
                    <r-button
                        fluid
                        @click="$emit('add-action', 'send-email')">
                        <span v-if="hasNoActions">Add Email</span>
                        <span v-else>Add another Email</span>
                    </r-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import EventModel from '@/common/models/rules/event-model';
    import vPopper from '@/components/v-popper';
    import {
        vIcon, vIconButton, vToggle,
    } from '@/components/form';
    import {createDialog, vConfirm} from '@/components/modal/dialogs';
    import SendEmail from '@/modules/rules-engine/actions/send-email/send-email';

    export default {
        name: 'email-actions-list',
        components: {
            vPopper, vToggle, vIcon, vIconButton, SendEmail,
        },
        props: {
            actions: Array,
            validationAggregator: Object,
            isFormUpdating: Boolean,
            preProcessor: Object,
            newActionPredicate: Function,
            event: {
                type: EventModel,
            },
        },
        computed: {
            hasNoActions() {
                return this.actions.length === 0;
            },
        },
        methods: {
            async confirmDelete(action, actionIndex) {
                const confirmDialog = createDialog(vConfirm, this);
                const dialogParams = {
                    title: `Delete ${this.$filters.unKebabCase(action.name)}`,
                    content: `Are you sure you want to delete this email? This cannot be undone.`,
                    confirmLabel: 'Delete',
                    dangerConfirm: true,
                };
                if (await confirmDialog(dialogParams)) {
                    this.$emit('delete-action', actionIndex);
                }
            },
            updateAction(action, index) {
                this.$emit('update-action', {action, index});
            },
        },
    };
</script>
